import { reactive } from 'vue';

// One help button, not three. Matt: "The how do I play button is too large.
// Let's put that into the question mark button at the top. We already have a
// question mark button up there. I don't even know what that does or how it's
// different... the question mark button could also take on the what do these
// mean and how do I play buttons."
//
// The header owns the button (App.vue) but only the phone knows which role
// you are looking at, so the phone writes it here and the menu reads it.
export const help = reactive({ open: false, role: null });

export const openHelp = () => { help.open = true; };
export const closeHelp = () => { help.open = false; };
